import { IonButton, IonIcon, IonImg, IonMenuToggle } from '@ionic/react';
import { checkmarkCircle, ellipsisVertical, informationCircleOutline } from 'ionicons/icons';
import React from 'react';
import { ReactSVG } from 'react-svg';

interface LinkPlayerInfoModalProps {
  onLinkPlayerClick: () => void;
  onMaybeLater: () => void;
}

const benefits = ['Track your play', 'See player leaderboards', 'Access to exclusive events'];

export const LinkPlayerInfoModal: React.FC<LinkPlayerInfoModalProps> = ({
  onLinkPlayerClick,
  onMaybeLater,
}) => {
  return (
    <div className="link-player-info-overlay" data-testid="linkPlayerInfoModal">
      <div className="link-player-info">
        <div className="link-player-info__header">
          <button className="link-player-dark__back-btn" onClick={onMaybeLater} aria-label="Back">
            <IonImg src="assets/images/back-arrow.svg" alt="Back" />
          </button>
          <IonImg
            src="assets/images/leaderboard-crown.png"
            alt="Crown"
            className="link-player-info__crown"
          />
          <IonMenuToggle>
            <button className="link-player-dark__menu-btn" aria-label="Menu">
              <IonIcon icon={ellipsisVertical} />
            </button>
          </IonMenuToggle>
        </div>

        <div className="link-player-info__body">
          <div className="link-player-info__title-block">
            <IonImg
              src="assets/images/player-info-leaf-left.svg"
              alt=""
              aria-hidden="true"
              className="link-player-info__leaf link-player-info__leaf--left"
            />
            <div className="link-player-info__title-text">
              <h1 className="link-player-info__title">
                LINK <span className="link-player-info__title-playerid">PLAYER ID</span>
              </h1>
              <span className="link-player-info__title">TODAY</span>
            </div>
            <IonImg
              src="assets/images/player-info-leaf-right.svg"
              alt=""
              aria-hidden="true"
              className="link-player-info__leaf link-player-info__leaf--right"
            />
          </div>

          <div className="link-player-info__content">
            <p className="link-player-info__why-subtitle">Why Link ID?</p>

            <ul className="link-player-info__benefits">
              {benefits.map((benefit) => (
                <li key={benefit} className="link-player-info__benefit">
                  <ReactSVG src="assets/icon/check-mark.svg" />
                  <span className="link-player-info__benefit-text">{benefit}</span>
                </li>
              ))}
            </ul>

            <IonButton
              expand="block"
              className="link-player-dark__cta-btn"
              data-testid="linkPlayerInfoCta"
              onClick={onLinkPlayerClick}
            >
              LINK PLAYER ID
            </IonButton>

            <IonButton
              expand="block"
              fill="clear"
              className="link-player-dark__maybe-later-btn"
              onClick={onMaybeLater}
            >
              GO BACK
            </IonButton>

            <div className="link-player-info__details">
              <div className="link-player-info__details-header">
                <IonIcon
                  icon={informationCircleOutline}
                  className="link-player-info__details-icon"
                />
                <span className="link-player-info__details-label">DETAILS</span>
              </div>
              <p className="link-player-info__details-body">
                A Player ID is given to registered players at each casino. This is necessary to
                track player information. Connecting your Player ID to your Slot Check account lets
                you see your MyPlay, allows access to Leaderboards and other exclusive Events and
                features.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkPlayerInfoModal;
